<div [formGroup]="communicationForm" *ngIf="communicationForm && isGeneralNotification" class="container-fluid communication-modal">
    <div class="row">
        <div class="col-9">
            <mat-label class="font-style">
                <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.COMMUNICATE_WITH_ALL_USERS' | transloco }}:</h4>
            </mat-label>
        </div>
        <div class="col-3 d-flex justify-content-end">
            <a class="close-icon" href="javascript:void()" (click)="btnCancelClicked()">
                <span class="modal-header-info">{{ 'SETTING_PAGE.IDMS_SETTINGS.GENERAL_ANNOUNCEMENT' | transloco }}</span>
                <i class="flaticon2-cross ms-4"></i>
            </a>
        </div>
    </div>
    <div class="row mt-3 mb-3">
        <div class="col-5">
            <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                <input
                    type="text"
                    formControlName="title"
                    matInput
                    placeholder="{{ 'SETTING_PAGE.IDMS_SETTINGS.TITLE' | transloco }}"
                    [readonly]="modalType == 1"
                    (keypress)="onKeyPress($event)"
                    (paste)="onKeyPress($event)"
                />
            </mat-form-field>
        </div>
    </div>
    <div class="row mt-3 mb-3">
        <div class="col">
            <dx-html-editor
                height="400px"
                [value]="valueContent"
                (onValueChanged)="onEditorValueChanged($event)"
                (keypress)="onKeyPress($event)"
                (paste)="onKeyPress($event)"
            >
                <dxo-toolbar [multiline]="isMultiline">
                    <dxi-item name="undo"></dxi-item>
                    <dxi-item name="redo"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item
                        name="size"
                        [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
                    ></dxi-item>
                    <dxi-item
                        name="font"
                        [acceptedValues]="['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']"
                        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
                    ></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="bold"></dxi-item>
                    <dxi-item name="italic"></dxi-item>
                    <dxi-item name="strike"></dxi-item>
                    <dxi-item name="underline"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="alignLeft"></dxi-item>
                    <dxi-item name="alignCenter"></dxi-item>
                    <dxi-item name="alignRight"></dxi-item>
                    <dxi-item name="alignJustify"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="orderedList"></dxi-item>
                    <dxi-item name="bulletList"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]" [options]="{ inputAttr: { 'aria-label': 'Header' } }"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="color"></dxi-item>
                </dxo-toolbar>
                <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
            </dx-html-editor>
        </div>
    </div>
    <div class="row" style="margin-top: 10px">
        <div class="col-md-10 col-lg-10 col-sm-6">
            <div class="row mt-3 mb-3">
                <div formGroupName="calender_group" class="col-md-12 col-lg-8">
                    <div class="row mt-3 mb-3">
                        <div class="col-md-6">
                            <div class="date-picker">
                                <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFY_FROM' | transloco }}</mat-label>
                                <dx-date-box
                                    class="dx-date-custom-wrapper"
                                    [min]="currentDate"
                                    formControlName="startDate"
                                    displayFormat="dd-MMM-yyyy"
                                    [inputAttr]="{ 'aria-label': 'Choose Start Date' }"
                                    [disabled]="modalType == 1"
                                    blockDateTyping
                                >
                                </dx-date-box>
                                <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->

                                <span
                                    class="text-danger"
                                    *ngIf="communicationForm.get('calender_group').get('startDate').hasError('matDatepickerMin') && modalType !== 1"
                                    >Invalid Date!</span
                                >
                                <span class="text-danger" *ngIf="communicationForm.get('calender_group').hasError('inValidStartDate') && modalType !== 1"
                                    >StartDate should be less than End date!</span
                                >
                                <span class="text-danger" *ngIf="communicationForm.get('calender_group').hasError('sameDateTime') && modalType !== 1"
                                    >Both date shoud not be same!</span
                                >
                            </div>
                        </div>
                        <div class="col-md-6 date-picker">
                            <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFY_UNTIL' | transloco }}</mat-label>
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                formControlName="endDate"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose End Date' }"
                                [disabled]="modalType == 1"
                                [min]="currentDate"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                            <span
                                class="text-danger"
                                *ngIf="communicationForm.get('calender_group').get('endDate').hasError('matDatepickerMin') && modalType !== 1"
                                >Invalid Date!</span
                            >
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-4">
                    <div class="row flex-column">
                        <div class="col">
                            <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_TYPES' | transloco }}:</mat-label>
                        </div>
                        <div class="col d-flex mt-3" formGroupName="checkbox_group">
                            <div class="check-box">
                                <mat-checkbox formControlName="email" class="example-margin checkbox-wrap" [disabled]="modalType == 1">{{
                                    'SETTING_PAGE.IDMS_SETTINGS.EMAIL' | transloco
                                }}</mat-checkbox>
                            </div>
                            <div class="check-box ms-5">
                                <mat-checkbox formControlName="mobile" class="example-margin checkbox-wrap" [disabled]="modalType == 1">
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.MOBILE_NOTIFICATION' | transloco }}
                                </mat-checkbox>
                            </div>
                            <div class="check-box ms-5">
                                <mat-checkbox formControlName="web" class="example-margin checkbox-wrap" [disabled]="modalType == 1">
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.WEB_NOTIFICATION' | transloco }}
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="col error-message">
                            <span
                                class="text-danger"
                                *ngIf="
                                    communicationForm.get('checkbox_group').hasError('requireOneCheckboxToBeChecked') &&
                                    communicationForm.get('checkbox_group').touched
                                "
                            >
                                atleast one checkbox should be checked!
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 d-flex justify-content-end add-button">
            <button
                type="button"
                class="btn primary-ebtn"
                *ngIf="communication == null"
                (click)="saveCommunication(0)"
                [disabled]="!(communicationForm.valid && characterCount < 151)"
            >
                {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
            </button>
            <button
                type="button"
                class="btn primary-ebtn"
                *ngIf="communication != null && modalType == 0"
                (click)="saveCommunication(1)"
                [disabled]="!(communicationForm.dirty && communicationForm.valid && characterCount < 151)"
            >
                {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
            </button>
            <button type="button" class="btn primary-ebtn" *ngIf="modalType == 1" (click)="ngbModal.dismissAll()">CANCEL</button>
        </div>
    </div>
</div>

<div class="modal-wrapper" [formGroup]="communicationForm" *ngIf="communicationForm && !isGeneralNotification">
    <div class="row mt-3 mb-3">
        <div class="col-8">
            <div class="d-flex justify-content-start align-items-center h-100">
                <mat-label class="font-style">
                    <h4 class="title-model">{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}:</h4>
                </mat-label>
            </div>
        </div>
        <div class="col-4">
            <div class="d-flex justify-content-end close-button">
                <span class="modal-header-info">{{ 'SETTING_PAGE.IDMS_SETTINGS.COMMUNICATE_WITH_ALL_USERS' | transloco }}</span>
                <a class="close-icon" href="javascript:void()" (click)="btnCancelClicked()">
                    <i class="flaticon2-cross"></i>
                </a>
            </div>
        </div>
        <div class="col-12" formGroupName="checkbox_group">
            <div class="communication-paragraph">
                <h4 class="title-communication">{{ 'SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_TYPES' | transloco }}:</h4>

                <div class="email-wrap d-flex justify-content-start align-items-center">
                    <div class="check-box">
                        <mat-checkbox formControlName="email" class="example-margin checkbox-wrap" [disabled]="modalType == 1">{{
                            'SETTING_PAGE.IDMS_SETTINGS.EMAIL' | transloco
                        }}</mat-checkbox>
                    </div>
                    <div class="check-box ms-5">
                        <mat-checkbox formControlName="mobile" class="example-margin checkbox-wrap" [disabled]="modalType == 1">{{
                            'SETTING_PAGE.IDMS_SETTINGS.MOBILE_NOTIFICATION' | transloco
                        }}</mat-checkbox>
                    </div>
                    <div class="check-box ms-5">
                        <mat-checkbox formControlName="web" class="example-margin checkbox-wrap" [disabled]="modalType == 1">{{
                            'SETTING_PAGE.IDMS_SETTINGS.WEB_NOTIFICATION' | transloco
                        }}</mat-checkbox>
                    </div>
                </div>
            </div>
            <span
                class="text-danger"
                *ngIf="communicationForm.get('checkbox_group').hasError('requireOneCheckboxToBeChecked') && communicationForm.get('checkbox_group').touched"
            >
                atleast one checkbox should be checked!
            </span>
        </div>
    </div>
    <div class="mt-5">
        <div class="row mt-3 mb-3">
            <div class="col-6">
                <div class="row mt-3 mb-3" formGroupName="maintenance_calender_group">
                    <div class="col-6 d-flex flex-column">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.MAINTENANCE_START_FROM' | transloco }}</mat-label>
                        <div class="dx-field-value dx-date-time-picker">
                            <dx-date-box
                                formControlName="startDate"
                                formet=""
                                type="datetime"
                                [value]=""
                                [inputAttr]="{ 'aria-label': 'Date And Time' }"
                                [disabled]="modalType == 1"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>

                        <span
                            class="text-danger"
                            *ngIf="communicationForm.get('maintenance_calender_group').get('startDate').hasError('matDatetimePickerMin') && modalType !== 1"
                            >Invalid Date!</span
                        >
                        <!-- {{ communicationForm.get('calender_group').get('startDate').hasError('inValidStartDate') }}*** -->
                        <span class="text-danger" *ngIf="communicationForm.get('maintenance_calender_group').hasError('inValidStartDate') && modalType !== 1"
                            >StartDate should be less than End date!</span
                        >
                        <span class="text-danger" *ngIf="communicationForm.get('maintenance_calender_group').hasError('sameDateTime') && modalType !== 1"
                            >Both date shoud not be same!</span
                        >
                    </div>
                    <div class="col-6 d-flex flex-column calender-main">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.MAINTENANCE_END_FROM' | transloco }}</mat-label>
                        <div class="dx-field-value dx-date-time-picker">
                            <dx-date-box
                                formControlName="endDate"
                                type="datetime"
                                [value]=""
                                [inputAttr]="{ 'aria-label': 'Date And Time' }"
                                [disabled]="modalType == 1"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>

                        <span
                            class="text-danger"
                            *ngIf="communicationForm.get('maintenance_calender_group').get('endDate').hasError('matDatetimePickerMin') && modalType !== 1"
                            >Invalid Date!</span
                        >
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="row mt-3 mb-3" formGroupName="calender_group">
                    <div class="col-5 calender-main">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFICATION_START_DATE' | transloco }}</mat-label>
                        <dx-date-box
                            class="dx-date-custom-wrapper"
                            formControlName="startDate"
                            displayFormat="dd-MMM-yyyy"
                            [inputAttr]="{ 'aria-label': 'Choose Start Date' }"
                            [disabled]="modalType == 1"
                            [min]="currentDate"
                            blockDateTyping
                        >
                        </dx-date-box>
                        <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        <span
                            class="text-danger"
                            *ngIf="communicationForm.get('calender_group').get('startDate').hasError('matDatepickerMin') && modalType !== 1"
                            >Invalid Date!</span
                        >
                        <span class="text-danger" *ngIf="communicationForm.get('calender_group').hasError('inValidStartDate') && modalType !== 1"
                            >StartDate should be less than End date!</span
                        >
                        <span class="text-danger" *ngIf="communicationForm.get('calender_group').hasError('sameDateTime') && modalType !== 1"
                            >Both date shoud not be same!</span
                        >
                    </div>
                    <div class="col-5">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFICATION_END_DATE' | transloco }}</mat-label>
                        <dx-date-box
                            class="dx-date-custom-wrapper"
                            [min]="currentDate"
                            formControlName="endDate"
                            displayFormat="dd-MMM-yyyy"
                            [inputAttr]="{ 'aria-label': 'Choose End Date' }"
                            [disabled]="modalType == 1"
                            blockDateTyping
                        >
                        </dx-date-box>
                        <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        <span class="text-danger" *ngIf="communicationForm.get('calender_group').get('endDate').hasError('matDatepickerMin') && modalType !== 1"
                            >Invalid Date!</span
                        >
                    </div>
                    <div class="col-2">
                        <div class="d-flex justify-content-end align-items-center h-100">
                            <button
                                type="button"
                                class="btn primary-ebtn"
                                *ngIf="communication == null"
                                (click)="saveCommunication(0)"
                                [disabled]="!communicationForm.valid"
                            >
                                {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
                            </button>
                            <button
                                type="button"
                                class="btn primary-ebtn"
                                *ngIf="communication != null && modalType == 0"
                                (click)="saveCommunication(1)"
                                [disabled]="!(communicationForm.dirty && communicationForm.valid)"
                            >
                                {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
                            </button>
                            <button type="button" class="btn primary-ebtn" *ngIf="modalType == 1" (click)="ngbModal.dismissAll()">
                                {{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
